import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function LoginPage() {
  const { login, register, setupRequired } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) return;
    setLoading(true);
    setError('');
    try {
      if (setupRequired) {
        await register(username.trim(), password.trim());
      } else {
        await login(username.trim(), password.trim());
      }
    } catch (err: any) {
      setError(err.response?.data?.message || err.message || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.wrapper}>
      <form style={s.card} onSubmit={handleSubmit}>
        <h2 style={s.title}>
          {setupRequired ? 'Create Admin Account' : 'Sign In'}
        </h2>
        {setupRequired && (
          <p style={s.hint}>No users yet. Create the first admin account.</p>
        )}

        <label style={s.label}>
          Username
          <input style={s.input} value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
        </label>

        <label style={s.label}>
          Password
          <input style={s.input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>

        {error && <div style={s.error}>{error}</div>}

        <button style={s.btn} type="submit" disabled={loading || !username.trim() || !password.trim()}>
          {loading ? 'Loading...' : setupRequired ? 'Create Account' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  wrapper: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f5f5f5', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  card: { width: 360, padding: '32px', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column', gap: 14 },
  title: { margin: 0, fontSize: 20, color: '#1a1a1a' },
  hint: { margin: 0, fontSize: 13, color: '#888' },
  label: { display: 'flex', flexDirection: 'column', gap: 4, fontSize: 13, color: '#555' },
  input: { padding: '10px 14px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, outline: 'none' },
  error: { padding: '8px 12px', background: '#fff0f0', border: '1px solid #fcc', borderRadius: 8, color: '#c00', fontSize: 13 },
  btn: { padding: '10px 20px', borderRadius: 8, border: 'none', background: '#4f46e5', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
};
